export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 992;
